import { isClient } from '@vueuse/core'

// 获取浏览器语言
const jcLanguage = 'jc-language'
export function setCurrentLanguage(language: string) {
  if (typeof window !== 'undefined') {
    const topDomain = getFirstDomain()
    const langCookie = useCookie(jcLanguage, {
      domain: topDomain || undefined,
    })
    langCookie.value = language
  }
}

export function getCurrentLanguage() {
  if (isClient) {
    const topDomain = getFirstDomain()
    const langCookie = useCookie(jcLanguage, {
      domain: topDomain || undefined,
    })
    return langCookie.value
  }
  return null // 如果在服务器端，返回 null 或者默认语言
}
